
/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
// import { asyncConnect } from 'redux-connect';
import _ from 'lodash';
import GiftPreferencesWeb from './components/GiftPreferencesWeb';
import GiftPreferencesWap from './components/GiftPreferencesWap';
import * as labelsActions from '../../../../../components/labels/actions';
import * as giftPreferencesActions from './actions';
import commonUtil from '../../../../../utils/commonUtil';
import ApplyCSS from '../../../../../components/ApplyCSS';
import * as defaultConst from '../../../../../utils/clientConstant';
import Tagging from '../../../../../components/Tagging/Tagging';
// import Warning from '../../../../../components/Warning';

const applicationRoutes = commonUtil.getApplicationRoutes();

const channel = commonUtil.getChannel();

const { preferredDeliveryDayDetails,
  saveDayoftheWeekForAddress,
  //handleChangeAddressPreference,
  handleTemproryChangesInPreference,
  handleCancelTemproryAddressPreferenceChanges,
  handleChangesInPreference,
  } = giftPreferencesActions;


@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
}),
  {
    ...labelsActions,
    ...giftPreferencesActions,
  })

// TODO: Not use. Review and remove files relates next time.
class GiftPreferences extends Component {
  constructor(props) {
    super(props);
    this.eventStatusForSuspended = '';
    this.warningMessage = '';
    this.state = {
      showButton: false,
      selectedAddressForChangePreference: '',

    };
  }

  _resetSelectedAddress = () => {
    this.setState({
      ...this.state,
      selectedAddressForChangePreference: '',
    });
  }
  _showSelectedAddress = (address) => {
    this.setState({
      ...this.state,
      selectedAddressForChangePreference: address,
    });
  }
  componentDidMount() {
    const user = this.props.user;
    if (!(user && user.result && user.result.status && user.result.status.status === defaultConst.constAPISuccess)) {
      if (browserHistory) {
        browserHistory.push('/');
      }
    }

    this.eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
    if (this.eventID) {
      this.props.preferredDeliveryDayDetails(this.eventID, 'true');
    }

    const eventUrl = 'gestiondeeventos/PreferenciaDeEntregaDeRegalos/';

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'vPageView',
      GroupOne: eventUrl,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Preferencia de entrega de regalos',
      Site: 'Mesa de Regalos',
      idMesa: this.eventID,
    });
  }

  // WAP
  waphandleSumbitChangedAddressPreference = (prefernce) => {
    const newPrefernce = JSON.parse(JSON.stringify(prefernce));
    const saveDayoftheWeekInfo = [];
    // let subscribed = false;
    newPrefernce.forEach((address) => {
      const newDays = [];
      address.days.forEach(item => item.opted === true && newDays.push(item.deliveryDay));
      if (newDays.length) {
        // subscribed = true;
        saveDayoftheWeekInfo.push({
          addressId: address.addressId,
          days: newDays,
        });
      } else {
        // subscribed = false;
        saveDayoftheWeekInfo.push({
          addressId: address.addressId,
          days: [],
        });
      }
    });
    saveDayoftheWeekForAddress(saveDayoftheWeekInfo, this.eventID).then((response) => {
      if (response.body.status.status === 'success') {
        const button = document.querySelector('.btnPrimaryAction');
        button.style.display = 'none';
        this.props.preferredDeliveryDayDetails(this.eventID, 'true');
      }
    });
  }

  // WEB function for DayoftheWeekForAddress service call
  handleSumbitChangedAddressPreference = () => {
    this.deliveryDayAndAddressInfo = this.giftPref.getUpdatedData();
    const saveDayoftheWeekInfo = [];
    let opted = false;
    this.deliveryDayAndAddressInfo.forEach((address) => {
      const temp = {};
      const selectedDays = [];
      address.delieveryDaysInfo.forEach((day) => {
        if (day.opted === true) {
          selectedDays.push(day.deliveryDay);
        }
      });
      temp.addressId = address.addressId;
      temp.days = selectedDays;
      if (selectedDays.length) {
        opted = true;
      }
      if (!_.isEmpty(selectedDays)) {
        saveDayoftheWeekInfo.push(temp);
      } else {
        saveDayoftheWeekInfo.push(temp);
      }
    });

    saveDayoftheWeekForAddress(saveDayoftheWeekInfo, this.eventID).then((response) => {
      if (response.body.status.status === 'success') {
        const button = document.querySelector('.giftPAButtons');
        button.style.display = 'none';
        this.props.preferredDeliveryDayDetails(this.eventID, opted.toString());
      }
    });
  }

  changeAddressDeliveryPreference = () => {
    /* eslint-disable */
    let button = document.querySelector('.giftPAButtons');
    button.style.display = 'block';
    /* eslint-enable*/
  }


  _handleCancelTemproryAddressPreferenceChanges = () => {
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.eventManagement, { pageName: 'DatosDeMiEvento', eventID: this.eventID }));
  }

  _handleCancelAllChanges = () => {

  }
  getRegisteredGiftList = () => {
    this.props.getRegisteredGiftList();
  }
  _handleChangeAddressesPreference = () => {
    this.props.handleChangeAddressPreference();
  }


  // componentWillMount() {
  //   const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
  //   const currentEventStatus = this.props.eventStatus;

  //   // for Suspended & closed event Status
  //   let eventStatusForSuspended = false;
  //   currentEventStatus.map((temp) => {
  //     if (temp.eventId === eventID) {
  //       if ([defaultConst.constEventStatus.SUSPENDED, defaultConst.constEventStatus.VALIDITYOFFACTIVE, defaultConst.constEventStatus.CLOSED].indexOf(temp.eventStatus) > -1) {
  //         eventStatusForSuspended = true;
  //       }
  //     } return eventStatusForSuspended;
  //   });
  // }
  render() {
    const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
    const currentEventStatus = this.props.eventStatus;

    // for Suspended & closed event Status
    let eventStatusForSuspended = false;
    currentEventStatus.map((temp) => {
      if (temp.eventId === eventID) {
        if ([defaultConst.constEventStatus.SUSPENDED, defaultConst.constEventStatus.VALIDITYOFFACTIVE, defaultConst.constEventStatus.CLOSED].indexOf(temp.eventStatus) > -1) {
          eventStatusForSuspended = true;
        }
      } return eventStatusForSuspended;
    });
    const pref = this.props.deliveryDayPreference;
    if (pref.status && pref.status.errorMessage && pref.status.status === defaultConst.constAPIFailure) {
      return (
        <div>
          <ApplyCSS pageName="giftPreferences" />
          <Tagging ref={tagging => this.tagging = tagging} />
          {channel && channel === 'web' ?
            <div className="row">
              <div className="col-sm-9 myEventInfo noBorder addressIntro">
                <h1>Preferencias de entrega de regalos</h1>
                <div className="alertError">
                  <i className="icon-tache2" />
                  <p>{pref && pref.status ? pref.status.errorMessage : null}</p>
                </div>

              </div>
            </div> :
            <div className="myEventContent">
              <div className="row">
                <div className="col-xs-12">
                  <h1 className="noBorder">Preferencias de entrega de regalos</h1>
                  <div className="alertError">
                    <i className="icon-tache2" />
                    <p>{pref && pref.status ? pref.status.errorMessage : null}</p>
                  </div>
                </div>
              </div>
            </div>

          }
        </div>
      );
    }
    // this.deliveryDayAndAddressInfo = JSON.parse(JSON.stringify(this.props.deliveryDayPreference.preferredDeliveryDayDetails.deliveryDayAndAddressInfo));
    // this._tempDeliveryDayPreference = this.props.deliveryDayPreference.preferredDeliveryDayDetails.deliveryDayAndAddressInfo;
    // this.deliveryDayNotApplicables = JSON.parse(JSON.stringify(this.props.deliveryDayNotApplicables));
    return (
      <div>
        <ApplyCSS pageName="giftPreferences" />
        <Tagging ref={tagging => this.tagging = tagging} />
        {channel && channel === 'web' ?
          <GiftPreferencesWeb
            {...this.props}
            warningMessage={this.warningMessage}
            ref={(gp) => { this.giftPref = gp; }}
            // _tempDeliveryDayPreference={this.props._tempDeliveryDayPreference}
            showAddressWithPreference={this.showAddressWithPreference}
            // deliveryDayAndAddressInfo={this.deliveryDayAndAddressInfo}
            // deliveryDayNotApplicables={this.deliveryDayNotApplicables}
            changeAddressDeliveryPreference={this.changeAddressDeliveryPreference}
            handleSumbitChangedAddressPreference={this.handleSumbitChangedAddressPreference}
            _handleCancelTemproryAddressPreferenceChanges={this._handleCancelTemproryAddressPreferenceChanges}
            lables={this.props.lables}
            eventStatusForSuspended={eventStatusForSuspended}
          />
          :
          <GiftPreferencesWap
            {...this.props}
            warningMessage={this.warningMessage}
            ref={(gp) => { this.giftPrefWap = gp; }}
            _handleChangeAddressesPreference={this._handleChangeAddressesPreference}
            _showSelectedAddress={this._showSelectedAddress}
            /* showAddressWithPreference={this.showAddressWithPreference} */
            /* changeAddressPreferenceWap={this.changeAddressPreferenceWap} */
            selectedAddressForChangePreference={this.state.selectedAddressForChangePreference}
            waphandleSumbitChangedAddressPreference={this.waphandleSumbitChangedAddressPreference}
            saveDayoftheWeekForAddress={saveDayoftheWeekForAddress}
            eventStatusForSuspended={eventStatusForSuspended}
          />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  lables: state.labels.data,
  user: state.user.data,
  myData: state,
  deliveryDayAndAddressInfo: state.giftPreferences && state.giftPreferences.data && state.giftPreferences.data.deliveryDayPreference && state.giftPreferences.data.deliveryDayPreference.preferredDeliveryDayDetails && state.giftPreferences.data.deliveryDayPreference.preferredDeliveryDayDetails.deliveryDayAndAddressInfo ? state.giftPreferences.data.deliveryDayPreference.preferredDeliveryDayDetails : null,
  deliveryDayPreference: state.giftPreferences && state.giftPreferences.data && state.giftPreferences.data.deliveryDayPreference ? state.giftPreferences.data.deliveryDayPreference : null,
  deliveryDayNotApplicables: state.giftPreferences && state.giftPreferences.data && state.giftPreferences.data.deliveryDayNotApplicables ? state.giftPreferences.data.deliveryDayNotApplicables : null,
  eventStatus: state.eventDetail.data?.eventList,
});
const matchDispatchToProps = dispatch => bindActionCreators({
  preferredDeliveryDayDetails,
  handleChangeAddressPreference,
  handleTemproryChangesInPreference,
  handleCancelTemproryAddressPreferenceChanges,
  handleChangesInPreference,
}, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(GiftPreferences);
